import * as React from 'react';
import { hslToHex } from './utils';

function fixCanvas(canvas) {
	// Get the device pixel ratio, falling back to 1.
	var dpr = window.devicePixelRatio || 1;

	let style_height = +getComputedStyle(canvas).getPropertyValue('height').slice(0, -2); //get CSS width
	let style_width = +getComputedStyle(canvas).getPropertyValue('width').slice(0, -2); //scale the canvas
	canvas.setAttribute('height', style_height * dpr);
	canvas.setAttribute('width', style_width * dpr);

	return canvas;
}
class PianoRoll extends React.Component {
	constructor(props) {
		super(props);
		this.canvas = React.createRef();
	}

	componentDidUpdate() {
		this.draw();
	}

	draw() {
		let canvas = this.canvas.current;
		canvas = fixCanvas(canvas);
		const h = canvas.height;
		const w = canvas.width;
		let ctx = canvas.getContext('2d');

		let { notes, minPitch, maxPitch, nMillis, isOdeToJoy } = this.props.score;
		let displayDuration = this.props.displayDuration;

		let nPitches = maxPitch - minPitch;

		let ppms = w / displayDuration;

		if (isOdeToJoy) {
			//QUICK FIX BECAUSE SOMETHING IS UP WITH THE MIDI PARSING
			ppms = 1.67 * ppms;
		}

		let ppp = h / (nPitches + 1);

		if (notes) {
			notes.forEach((n) => {
				let nh = ppp * (n.pitch - minPitch);
				let start = n.startMillis * ppms;
				let end = n.endMillis * ppms;
				ctx.fillStyle = hslToHex(
					120 + (100.0 * n.velocity) / 127.0,
					10.0,
					(100.0 * (127.0 - n.velocity)) / 127.0
				);
				ctx.fillRect(start, h - (nh - ppp / 2), end - start, ppp);
			});
		}
	}

	render() {
		return (
			<canvas
				style={{ width: '100%', height: '100%', border: '1 px solid black' }}
				// width={this.props.width}
				// height={this.props.height}
				ref={this.canvas}
			/>
		);
	}
}

export default PianoRoll;
